<script>
import gql from "graphql-tag";
import { tournamentMatchEndedFragment } from "@/graphql/tournament";
import { DialogInputTypes } from "@/js/helper";
import BaseDialog from "./baseDialog.vue";
import { MatchTools } from "@/js/helper";

export default {
  name: "MatchEndDialog",
  extends: BaseDialog,
  props: { tournament: Object, match: Object },
  data: function() {
    return {
      winner: {
        label: "Winner",
        value: this.match.firstCompetitor.name,
        options: [
          {
            value: this.match.firstCompetitor.id,
            display: this.match.firstCompetitor.name
          },
          {
            value: this.match.secondCompetitor.id,
            display: this.match.secondCompetitor.name
          }
        ]
      },
      score: { label: "Score" },
      winnerPoints: {
        label: "Points for winner",
        type: DialogInputTypes.number,
        hint: "If points are important"
      },
      loserPoints: {
        label: "Points for loser",
        type: DialogInputTypes.number,
        hint: "If points are important"
      }
    };
  },
  computed: {
    dialogInputs: {
      get() {
        return [this.winner, this.score, this.winnerPoints, this.loserPoints];
      }
    },
    title: {
      get() {
        return `End match - ${this.match.name}`;
      }
    },
    instructions: {
      get() {
        return MatchTools.competitorsDescription(this.match);
      }
    }
  },
  methods: {
    submit() {
      return this.$apollo
        .mutate({
          mutation: gql`
            mutation(
              $tournamentId: ID!
              $matchId: ID!
              $winnerId: ID!
              $score: String
            ) {
              endMatch(
                tournamentId: $tournamentId
                matchId: $matchId
                winnerId: $winnerId
                score: $score
              ) {
                ...TournamentMatchEnded
              }
            }
            ${tournamentMatchEndedFragment}
          `,
          variables: {
            tournamentId: this.tournament.id,
            matchId: this.match.id,
            winnerId: this.winner.value,
            score: this.score.value,
            winnerPoints: this.winnerPoints.value,
            loserPoints: this.loserPoints.value
          }
        })
        .then(result => {
          //this.$root.$emit("updateTournament", this.tournament.id);
          this.$store.commit(
            "setNotification",
            `Match ${this.match.name} has been marked as ended`
          );
        })
        .catch(err => {
          console.log(err);
          window.alert("Failed to end the match");
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// matchEndDialog.vue?be8d9308